import React, { useState } from 'react';
import Button from '@material-ui/core/Button';
import axios from 'axios'
import HubspotForm from 'react-hubspot-form'

const styles = {
    videosWrapper: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-around',
        alignItems: 'first baseline',
        padding: '50px',
        margin: '50px',
        backgroundColor: 'white',
        borderRadius: '5px',
        boxShadow: '2px 2px 4px gray',
        maxWidth: '80%'
    },
    quizWrapper: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        padding: '50px',
        margin: '50px',
        backgroundColor: 'white',
        borderRadius: '5px',
        boxShadow: '2px 2px 4px gray',
        maxWidth: '80%'
    },
    button: {
        alignSelf: 'first baseline',
        fontSize: 'small',
        color: "white",
        background: "#9ca0a6",
        borderRadius: '10px',
        textAlign: 'center',
        padding: '5px',
        paddingLeft: '10px',
        paddingRight: '10px',
        marginBottom: '25px'
    },
    videoContainer: {
        alignSelf: 'center',
        border: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.025)',
        border: '1px solid rgba(0, 0, 0, 0.05)',
        maxWidth: '80%',
        padding: '20px',
        overflow: 'auto',
        position: 'relative',
        margin: '20px',
        display: 'none',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center'
    }
}

const VideoShow = props => {
    const [searchedVideos, setSearchedVideos] = useState(false)
    const [showVideos, setshowVideos] = useState([])

    function toggleVideo(videoId) {
        const vidElem = document.getElementById(videoId)
        if (vidElem.style.display === "none") {
            vidElem.style.display = "flex";
        } else {
            vidElem.style.display = "none";
        }
    }

    async function getPlaylistData(etag) {
        if (!searchedVideos) {
            setSearchedVideos(true)
            const vidData = await axios.get('/api/videos')
            setshowVideos(vidData.data.items)
        }
    }

    function createVideo(video) {
        return (
            <div key={video.snippet.resourceId.videoId} >
                <Button style={styles.button} onClick={() => toggleVideo(video.snippet.resourceId.videoId)}>{video.snippet.title}</Button>
                <div id={video.snippet.resourceId.videoId} style={styles.videoContainer}>
                    <iframe width="560" height="315" src={`https://www.youtube.com/embed/${video.snippet.resourceId.videoId}`} frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
                </div>
            </div>)
    }

    function renderVideos() {
        const divs = []
        for (let video of showVideos) divs.push(createVideo(video))
        return divs
    }

    getPlaylistData()

    const div = renderVideos()
    return (
        <div>
            <div id="forms" style={styles.videosWrapper}>
                {div}
            </div>
            <div style={styles.quizWrapper}>
                <HubspotForm
                    portalId='5425670'
                    formId='22bd9d7a-6a13-47ff-a546-17c2c23e92ee'
                    onReady={(form) => console.log('Form ready!')}
                    loading={<div>Loading...</div>}
                />
            </div>
        </div>
    )

}

export default VideoShow